import { CONDITIONS_DETAIL_CANONICAL } from '../../constants/defaults';
import _ from 'lodash';
export const getLdJson = condition => {
  let structuredData = {
    '@context': 'https://schema.org',
    publisher: {
      '@type': 'Organization',
      name: 'SingleCare',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.singlecare.com/blog/wp-content/themes/singlecare_blog/images/top-bar-logo-new.png'
      }
    },
    '@type': 'MedicalWebPage',
    headline: condition && condition.title,
    description: condition && condition.metaDescription,
    articleSection: 'Conditions',
    author: {
      '@type': 'Organization',
      name: 'SingleCare',
      logo: {
        '@type': 'ImageObject',
        url: 'https://www.singlecare.com/blog/wp-content/themes/singlecare_blog/images/top-bar-logo-new.png'
      }
    },
    reviewedBy:
      condition && !_.isEmpty(condition.medicalReviewer)
        ? `${condition.medicalReviewer[0].name}${
            condition.medicalReviewer[0].qualifications &&
            ',' + condition.medicalReviewer[0].qualifications
          }`
        : '',
    url: `${CONDITIONS_DETAIL_CANONICAL}${condition && condition.slug}`,
    datePublished: condition && condition.publishedAt,
    dateModified: condition && condition.publishedAt,
    keywords: ['Treatments'],
    relatedLink: [],
    image: ''
  };
  return JSON.stringify(structuredData);
};
